import { useState } from 'react';
import { ExecutionMode, ExecutionState } from '../interfaces/ui';

export default function useTestcaseExecutionState() {
  const [executionState, setExecutionState] = useState<ExecutionState>({
    executingProjectId: null,
    executingProjectName: '',
    executingRunId: null,
    executingMode: 'GENERATE',
    showResultsWorkspace: false,
    resultsProjectId: null,
  });

  const startExecution = (
    projectId: string,
    projectName: string,
    mode: ExecutionMode,
    runId: string,
  ) =>
    setExecutionState(prev => ({
      ...prev,
      executingProjectId: projectId,
      executingProjectName: projectName,
      executingRunId: runId,
      executingMode: mode,
    }));

  const closeExecution = () =>
    setExecutionState(prev => ({
      ...prev,
      executingProjectId: null,
      executingProjectName: '',
      executingRunId: null,
    }));

  const openResults = (projectId: string) =>
    setExecutionState(prev => ({
      ...prev,
      showResultsWorkspace: true,
      resultsProjectId: projectId,
      executingProjectId: null,
    }));

  const closeResults = () =>
    setExecutionState(prev => ({
      ...prev,
      showResultsWorkspace: false,
      resultsProjectId: null,
    }));

  return {
    executionState,
    startExecution,
    closeExecution,
    openResults,
    closeResults,
  };
}
